/**
 * Module dependencies.
 */

import { Container } from 'components/atoms/container/container';
import { JSX } from 'react';
import { ProductList } from '../product-list/product-list';
import { StyledSubTitle } from './category-products.style';
import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  category: any;
};

/**
 * Export `CategoryProducts` component.
 */

export function CategoryProducts({ category }: Props): JSX.Element {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <>
      {category.subCategories.map((subCategory: any) => {
        return (
          <Container key={subCategory.id}>
            {subCategory.title.en !== 'default' && (
              <StyledSubTitle>
                {subCategory.title[lang] ?? 'N/A'}
              </StyledSubTitle>
            )}

            <ProductList category={category} subCategory={subCategory} />
          </Container>
        );
      })}
    </>
  );
}
